import { ExpenseCategory } from "@/types/expenseCategory";
import { Space, Switch, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ColumnsProps } from "@/components/table";
import { ColumnsType } from "antd/es/table";

type GetColumnsProps = ColumnsProps<ExpenseCategory> & {
  onToggleActive?: (id: string, isActive: boolean) => void;
};

export const getColumns = ({
  onEdit,
  onToggleActive,
  filterOptions,
  filterValues,
  getSortOrder,
}: GetColumnsProps): ColumnsType<ExpenseCategory> => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    sortOrder: getSortOrder?.("name"),
    filters: filterOptions?.name,
    filterSearch: true,
    filteredValue: filterValues?.name || null,
  },
  {
    title: "Expense Type",
    dataIndex: ["expense_type", "name"],
    key: "expense_type_id",
    sorter: true,
    sortOrder: getSortOrder?.("expense_type.name"),
    filters: filterOptions?.expense_type_id,
    filterSearch: true,
    filteredValue: filterValues?.expense_type_id || null,
    render: (name: string) => name || "-",
  },
  {
    title: "Active",
    dataIndex: "is_active",
    key: "is_active",
    sorter: true,
    sortOrder: getSortOrder?.("is_active"),
    render: (isActive: boolean, record: ExpenseCategory) => (
      <Switch
        checked={isActive}
        onChange={(checked) => onToggleActive?.(record.id, checked)}
      />
    ),
  },
  {
    title: "Actions",
    key: "actions",
    width: 100,
    render: (_: any, record: ExpenseCategory) => (
      <Space size="small">
        <Tooltip title="Edit">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
            size="small"
          />
        </Tooltip>
      </Space>
    ),
  },
];
